import { Redirect } from '../constants/types';

function addRedirectUrlFromHeader<T extends Redirect>(data: T, header: string): T {
  if (header) {
    data.redirect = header;
  }

  return data;
}

export const AxiosHelper = {
  addRedirectUrlFromHeader,
};
